import createIcon from '../../createIcon';

/**
 * @component @name MailLock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgOS45N1Y2QzIxIDQuOSAyMC4xIDQgMTkgNEgzQzEuOSA0IDEuMDEgNC45IDEuMDEgNkwxIDE4QzEgMTkuMSAxLjkgMjAgMyAyMEgxNVYxNC45N0MxNSAxMi4yMSAxNy4yNCA5Ljk3IDIwIDkuOTdIMjFaTTE5IDhMMTEgMTNMMyA4VjZMMTEgMTFMMTkgNlY4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIyIDE1VjE0QzIyIDEyLjkgMjEuMSAxMiAyMCAxMkMxOC45IDEyIDE4IDEyLjkgMTggMTRWMTVDMTcuNDUgMTUgMTcgMTUuNDUgMTcgMTZWMTlDMTcgMTkuNTUgMTcuNDUgMjAgMTggMjBIMjJDMjIuNTUgMjAgMjMgMTkuNTUgMjMgMTlWMTZDMjMgMTUuNDUgMjIuNTUgMTUgMjIgMTVaTTIxIDE1SDE5VjE0QzE5IDEzLjQ1IDE5LjQ1IDEzIDIwIDEzQzIwLjU1IDEzIDIxIDEzLjQ1IDIxIDE0VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MailLock = createIcon('MailLock', [
  [
    'path',
    {
      d: 'M21 9.97V6C21 4.9 20.1 4 19 4H3C1.9 4 1.01 4.9 1.01 6L1 18C1 19.1 1.9 20 3 20H15V14.97C15 12.21 17.24 9.97 20 9.97H21ZM19 8L11 13L3 8V6L11 11L19 6V8Z',
      key: 'a0jw97',
    },
  ],
  [
    'path',
    {
      d: 'M22 15V14C22 12.9 21.1 12 20 12C18.9 12 18 12.9 18 14V15C17.45 15 17 15.45 17 16V19C17 19.55 17.45 20 18 20H22C22.55 20 23 19.55 23 19V16C23 15.45 22.55 15 22 15ZM21 15H19V14C19 13.45 19.45 13 20 13C20.55 13 21 13.45 21 14V15Z',
      key: '301p5z',
    },
  ],
]);

export default MailLock;
